export default __webpack_public_path__ + "static/pg_poziome_logo_kolor-300x212 alternatywna_2-156f2d43a166aa88e0acdce305b5d39a.jpg";